import React, { useEffect, useState } from "react";
import { dateFormator, mapTableRows } from "../../../../../utils";
import {
  Button,
  Divider,
  HeaderCard,
  InfoTimeCard,
  InvoicesHeader,
  KeyValue,
  NewTable,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
  Tag,
} from "../../../../../components";
import { ApprovalDetailsTableData } from "../../../../../assets/data/candidatesData";
import companyLogo from "../../../../../assets/images/tektree-logo-png-1.svg";
import EditWaitingforApprovalinvoic from "./EditWaitingforApprovalinvoic";
import { useNavigate } from "react-router-dom";
import { updateAccountPayablesStart } from "../../../../../redux/slices/accountPayables/accountPayablesSlice";
import { useDispatch } from "react-redux";
import axios from "axios";
import { ENDPOINTS, WORKFORCE_API_URL } from "../../../../../redux/apiConfig";
import { formatCurrency } from "../../../../../utils/stringUtils";
import QbAnimationLoading from "../../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";

const WaitingforApprovalinvoiceDetails = ({
  onBack,
  setReceivePayment,
  data,
}) => {
  console.log("data in waiting details", data);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [attachmentModal, setAttachmentModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  // const tableData = ApprovalDetailsTableData;
  const [tableData, setTableData] = useState([]);
  const [documentrow, setDocumentrow] = useState([]);
  const [qbLoading, setQbLoading] = useState(false);

  useEffect(() => {
    //     export const ApprovalDetailsTableData = [
    //   {
    //     Product: "Adeed Khan",
    //     Discription: "(11/17/2024 to 12/14/2024)",
    //     Quantity: "114",
    //     Rate: "48.00",
    //     Amount: "6912.00",
    //     client: "Milliennium software Inc",
    //     AccountTypes: "-",
    //   },
    // ];
    if (data.invoiceDetails) {
      setTableData(
        data.invoiceDetails.map((data) => ({
          Product: data.service || "",
          Discription: data.description || "",
          Quantity: data.quantity || "",
          Rate: data.rate || "",
          Amount: data.amount || "",
          client: data.clientId || "",
          AccountTypes: data.accountType || "", //??
        }))
      );
    }
    if (data.documents) {
      const result = data.documents.flatMap((doc) =>
        doc.file.flatMap((f) =>
          f.keys.map((k) => ({ name: f.name, filePath: k }))
        )
      );
      // const documentrow = [
      //   {
      //     DocumentTitle: "Title",
      //     Attachment: "Deloitteinnvoice.pdf",
      //   },
      // ];
      setDocumentrow(
        result.map((doc) => ({
          DocumentTitle: doc.name,
          Attachment: doc.name,
          link: doc.filePath,
        }))
      );
    }
  }, [data]);

  const fetchUrl = async (s3Key) => {
    try {
      const res = await axios.get(
        `${ENDPOINTS.UNIVERSAL.GET_S3_LINK}&key=${s3Key}`,
        { withCredentials: true }
      );
      console.log("response data for link generation", res);
      return res.data.data;
    } catch (err) {
      return "";
    } finally {
    }
  };

  const downloadFile = async (url, fileName = "downloaded-file") => {
    try {
      const urlData = await fetchUrl(url);
      const response = await fetch(urlData, {
        mode: "cors",
      });

      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Clean up blob URL
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Download error:", error);
    }
  };
  const columns = [
    {
      key: "Product",
      label: "Product/Service",
    },
    {
      key: "Discription",
      label: "Discription",
    },
    {
      key: "Quantity",
      label: "Quantity",
    },
    {
      key: "Rate",
      label: "Rate",
    },
    {
      key: "Amount",
      label: "Amount",
    },
    {
      key: "client",
      label: "client",
    },

    // as said to be commented
    // {
    //   key: "AccountTypes",
    //   label: "Account Types",
    // },
  ];
  const Documemtcolumns = [
    {
      key: "DocumentTitle",
      label: "Document Title",
    },
    {
      key: "Attachment",
      label: "Attachment",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="download"
            size="xs"
            variant="text"
            color="black"
            onClick={() => {
              console.log("download data", row.link);
              // downloadFile(row.link,row.DocumentTitle);
              downloadFile(row.link);
            }}
          />
          {/* <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="more_vert"
            size="xs"
            variant="text"
            color="black"
            onClick={""}  /> */}
        </div>
      ),
    },
  ];

  // const documentrow = [
  //   {
  //     DocumentTitle: "Title",
  //     Attachment: "Deloitteinnvoice.pdf",
  //   },
  // ];

  const mappedRows = mapTableRows(tableData, columns);
  const mappedRows3 = mapTableRows(documentrow, Documemtcolumns);

  if (isEditing) {
    return <EditWaitingforApprovalinvoic onBack={() => setIsEditing(false)} />;
  }
  const handlePrintInvoice = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    const html = `
    <html>
      <head>
        <title>Invoice PDF</title>
        <style>
          body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            padding: 30px;
            margin: 0;
            line-height: 1.6;
            color: #333;
          }
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            border-bottom: 2px solid #000;
            padding-bottom: 20px;
          }
          .logo-section h1 {
            font-size: 28px;
            font-weight: bold;
            margin: 0;
          }
          .invoice-info {
            text-align: right;
          }
          .invoice-number {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .status {
            background: #fef3c7;
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 12px;
          }
          .total-due {
            background: #dbeafe;
            padding: 15px;
            border-radius: 8px;
            text-align: right;
            margin: 20px 0;
          }
          .total-due-amount {
            font-size: 24px;
            font-weight: bold;
            color: #1e40af;
          }
          .address-section {
            display: flex;
            justify-content: space-between;
            margin: 30px 0;
            gap: 30px;
          }
          .address-box {
            flex: 1;
            background: #f9fafb;
            padding: 20px;
            border-radius: 8px;
          }
          .address-title {
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 10px;
            color: #374151;
          }
          .address-content {
            font-size: 14px;
            line-height: 1.5;
          }
          .invoice-details {
            background: #f9fafb;
            padding: 20px;
            border-radius: 8px;
            margin: 20px 0;
          }
          .detail-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
          }
          .detail-label {
            font-weight: 600;
          }
          .items-table {
            width: 100%;
            border-collapse: collapse;
            margin: 30px 0;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          }
          .items-table th {
            background: #374151;
            color: white;
            padding: 12px;
            text-align: left;
            font-weight: 600;
          }
          .items-table td {
            padding: 12px;
            border-bottom: 1px solid #e5e7eb;
          }
          .items-table tr:hover {
            background: #f9fafb;
          }
          .amount-column {
            text-align: right;
          }
          .totals-section {
            float: right;
            width: 400px;
            margin-top: 20px;
          }
          .total-row {
            display: flex;
            justify-content: space-between;
            padding: 10px 15px;
            border-bottom: 1px solid #e5e7eb;
          }
          .total-row.subtotal {
            background: #f9fafb;
            font-weight: 600;
          }
          .total-row.discount {
            color: #059669;
          }
          .total-row.final {
            background: #111827;
            color: white;
            font-weight: bold;
            font-size: 16px;
          }
          .memo-section {
            margin: 30px 0;
            padding: 15px;
            background: #fef9e7;
            border-left: 4px solid #f59e0b;
            border-radius: 4px;
          }
          .attachments-section {
            margin-top: 40px;
          }
          .attachments-title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 15px;
            color: #374151;
          }
          .attachments-table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #e5e7eb;
          }
          .attachments-table th,
          .attachments-table td {
            padding: 10px;
            border: 1px solid #e5e7eb;
            text-align: left;
          }
          .attachments-table th {
            background: #f3f4f6;
            font-weight: 600;
          }
          .footer {
            margin-top: 50px;
            text-align: center;
            font-size: 12px;
            color: #6b7280;
            border-top: 1px solid #e5e7eb;
            padding-top: 20px;
          }
          .clear {
            clear: both;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="logo-section">
            <h1>TekTree</h1>
          </div>
          <div class="invoice-info">
            <div class="invoice-number">Invoice #${data.invoiceNum || ""}</div>
            <div class="status">Waiting for approval</div>
          </div>
        </div>

        <div class="total-due">
          <div style="font-size: 14px; margin-bottom: 5px;">Total Due</div>
          <div class="total-due-amount">${data.amounts?.due || ""} USD</div>
        </div>

        <div class="address-section">
          <div class="address-box">
            <div class="address-title">From</div>
            <div class="address-content">
              <strong>TekTree LLC</strong><br>
              1106 Drummond Plaza, Newark, DE 19711<br>
              accounts@tektreeinc.com<br>
              www.tektreeinc.com
            </div>
          </div>
          <div class="address-box">
            <div class="address-title">To</div>
            <div class="address-content">
              <strong>${data.vendorId?.businessName || ""}</strong><br>
              ${(data.mailAddress || "")
                .split(",")
                .map((line) => line.trim())
                .join("<br>")}
            </div>
          </div>
        </div>

        <div class="invoice-details">
          <div class="address-title">Invoice Details</div>
          <div class="detail-row">
            <span class="detail-label">Invoice:</span>
            <span>${data.invoiceNum || ""}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Invoice Date:</span>
            <span>${dateFormator(data.invoiceDate, "month-day-year")}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Shipped Date:</span>
            <span>${dateFormator(data.invoiceDate, "month-day-year")}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Due Date:</span>
            <span>${dateFormator(data.dueDate, "month-day-year")}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Terms:</span>
            <span>${data.netTerms || ""}</span>
          </div>
        </div>

        ${
          data.items && data.items.length
            ? `
        <table class="items-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Qty</th>
              <th>Rate</th>
              <th class="amount-column">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${data.items
              .map(
                (item) => `
              <tr>
                <td>${item.description || ""}</td>
                <td>${item.quantity || ""}</td>
                <td>$${item.rate || ""}</td>
                <td class="amount-column">$${item.amount || ""}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        `
            : ""
        }

        <div class="totals-section">
          <div class="total-row subtotal">
            <span>Subtotal</span>
            <span>${
              parseFloat(data.amounts?.billed || 0) +
              parseFloat(data.amounts?.discount || 0)
            } USD</span>
          </div>
${
  data.discount?.length
    ? data.discount
        .filter((item) => item?.value)
        .map(
          (item) =>
            `<div class="total-row discount">
              <span>${item.name}</span>
              <span>-${item.value} USD</span>
            </div>`
        )
        .join("")
    : ""
}

          <div class="total-row final">
            <span>Total Due</span>
            <span>${data.amounts?.billed || ""} USD</span>
          </div>
        </div>

        <div class="clear"></div>

        ${
          data.memo
            ? `
        <div class="memo-section">
          <strong>Statement Memo:</strong> ${data.memo}
        </div>
        `
            : ""
        }

        <div class="attachments-section">
          <div class="attachments-title">Attachments</div>
          <table class="attachments-table">
            <thead>
              <tr>
                <th>File Name</th>
                <th>Uploaded On</th>
              </tr>
            </thead>
            <tbody>
              ${
                data.documents?.length
                  ? data.documents
                      .map(
                        (doc) => `
                <tr>
                  <td>${doc.file?.[0]?.name || ""}</td>
                  <td>${new Date(
                    doc.file?.[0]?.uploadedOn
                  ).toLocaleDateString()}</td>
                </tr>
              `
                      )
                      .join("")
                  : "<tr><td colspan='2'>No files</td></tr>"
              }
            </tbody>
          </table>
        </div>

        <div class="footer">
          Generated by TekTree Systems
        </div>
      </body>
    </html>
    `;

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  //testing
  // const openInvoiceWindow = (action = "print", fileName = "invoice.html") => {
  //   const content = document.getElementById("invoice-wrapper");
  //   if (!content) return;

  //   const clone = content.cloneNode(true);
  //   clone.querySelectorAll('[data-print="false"]').forEach((el) => el.remove());
  //   const fixStyles = `

  //     html, body {
  //       margin: 0;
  //       padding: 0;
  //       font-family: 'Inter', sans-serif;
  //       background-color: white;
  //       color: black;
  //       width: 100% !important;
  //       max-width: 100% !important;
  //       overflow-x: hidden !important;
  //       -webkit-print-color-adjust: exact !important;
  //       print-color-adjust: exact !important;
  //     }
  //     *, *::before, *::after {
  //       box-sizing: border-box;
  //       scrollbar-width: none;
  //     }
  //     ::-webkit-scrollbar {
  //       display: none;
  //     }
  //     div, section, main {
  //       overflow: visible !important;
  //       max-width: 100% !important;
  //     }
  //     #invoice-print-root {
  //       width: 100% !important;
  //       // max-width: 100% !important;
  //       max-width: none !important;
  //       overflow: visible !important;
  //       padding: 0 24px;
  //     }
  //     table {
  //       width: 100% !important;
  //       table-layout: auto !important;
  //       border-collapse: collapse;
  //       word-wrap: break-word !important;
  //       overflow-wrap: break-word !important;
  //       overflow: visible !important;
  //       background-color: white !important;
  //     }
  //     th, td {
  //       padding: 8px;
  //       text-align: left;
  //       border: 1px solid #d1d5db;
  //       font-size: 14px;
  //       word-break: break-word !important;
  //       white-space: normal !important;
  //     }
  //     thead {
  //       background-color: #f3f4f6;
  //     }
  //     img {
  //       max-width: 100%;
  //       height: auto;
  //       display: block;
  //     }
  //     @media print {
  //       html, body {
  //         zoom: 1 !important;
  //         width: 100% !important;
  //         max-width: 100% !important;
  //         overflow: visible !important;
  //       }
  //     }

  // `;

  //   const styleSheets = [
  //     ...document.querySelectorAll('link[rel="stylesheet"], style'),
  //   ]
  //     .map((el) => el.outerHTML)
  //     .join("\n");

  //   const fullHTML = `
  //   <html>
  //     <head>
  //       <title>${fileName}</title>
  //       <meta charset="UTF-8" />
  //       <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  //       <base href="${window.location.origin}/" />
  //       ${styleSheets}
  //       <style>
  //       ${fixStyles}
  //       </style>
  //     </head>
  //     <body>
  //       <div id="invoice-print-root">${clone.innerHTML}</div>
  //     </body>
  //   </html>
  // `;

  //   console.log({ fullHTML });

  //   if (action === "download") {
  //     const loadHtml2Pdf = () => {
  //       return new Promise((resolve, reject) => {
  //         if (window.html2pdf) return resolve(window.html2pdf);
  //         const script = document.createElement("script");
  //         script.src =
  //           "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
  //         script.onload = () => resolve(window.html2pdf);
  //         script.onerror = reject;
  //         document.body.appendChild(script);
  //       });
  //     };

  //     loadHtml2Pdf()
  //       .then((html2pdf) => {
  //         const iframe = document.createElement("iframe");
  //         iframe.style.position = "fixed";
  //         iframe.style.left = "-10000px";
  //         iframe.style.top = "0";
  //         iframe.style.width = "1400px";
  //         iframe.style.height = "1000px";
  //         iframe.style.border = "none";
  //         document.body.appendChild(iframe);

  //         iframe.contentDocument.open();
  //         iframe.contentDocument.write(fullHTML);
  //         iframe.contentDocument.close();

  //         const waitForLoad = () => {
  //           return new Promise((resolve) => {
  //             const win = iframe.contentWindow;
  //             const done = () => setTimeout(resolve, 1000);
  //             if (win.document.readyState === "complete") {
  //               done();
  //             } else {
  //               win.addEventListener("load", done);
  //             }
  //           });
  //         };

  //         waitForLoad().then(() => {
  //           const iframeDoc = iframe.contentDocument;
  //           const iframeWin = iframe.contentWindow;
  //           iframeWin.devicePixelRatio = 1;

  //           const root = iframeDoc.getElementById("invoice-print-root");
  //           if (!root) return console.error("Missing invoice-print-root");

  //           const allEls = root.querySelectorAll("*");
  //           allEls.forEach((el) => {
  //             const computed = iframeWin.getComputedStyle(el);
  //             for (let prop of computed) {
  //               const val = computed.getPropertyValue(prop);
  //               if (val.includes("oklch")) {
  //                 el.style.setProperty(prop, "rgb(0,0,0)", "important");
  //               }
  //             }
  //           });

  //           const opt = {
  //             margin: [0.5, 0.5, 0.5, 0.5],
  //             filename: fileName.endsWith(".pdf")
  //               ? fileName
  //               : `${fileName}.pdf`,
  //             image: { type: "jpeg", quality: 3 },
  //             html2canvas: {
  //               scale: 2,
  //               useCORS: true,
  //               allowTaint: true,
  //               // backgroundColor: "#ffffff",
  //               // windowWidth: 1400,
  //               // windowWidth: 100,
  //               windowHeight: 1000,
  //               scrollX: 0,
  //               scrollY: 0,
  //             },
  //             jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //             // jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //             pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  //           };

  //           html2pdf()
  //             .set(opt)
  //             .from(root)
  //             .save()
  //             .then(() => {
  //               iframe.remove();
  //             })
  //             .catch((err) => {
  //               console.error("PDF generation failed:", err);
  //               iframe.remove();
  //             });
  //         });
  //       })
  //       .catch((err) => {
  //         console.error("Failed to load html2pdf.js", err);
  //       });

  //     return;
  //   }

  //   const win = window.open("", "_blank", "height=1000,width=1200");
  //   if (!win) return;

  //   win.document.write(fullHTML);
  //   win.document.close();
  //   win.focus();

  //   if (action === "print") {
  //     const waitForPrint = () => {
  //       if (win.document.readyState === "complete") {
  //         setTimeout(() => {
  //           win.print();
  //           win.close();
  //         }, 800);
  //       } else {
  //         win.addEventListener("load", () => {
  //           setTimeout(() => {
  //             win.print();
  //             win.close();
  //           }, 800);
  //         });
  //       }
  //     };
  //     waitForPrint();
  //   }
  // };

  // const printInvoice = () =>
  //   openInvoiceWindow("print", `${data?.invoiceNum || "invoice"}`);
  // const viewInvoice = () => openInvoiceWindow("view");
  // const downloadInvoice = () =>
  //   openInvoiceWindow("download", `${data?.invoiceNum || "invoice"}.pdf`);

  const openInvoiceWindow = (action = "print", fileName = "invoice.html") => {
    const content = document.getElementById("invoice-wrapper");
    if (!content) return;

    const clone = content.cloneNode(true);
    clone.querySelectorAll('[data-print="false"]').forEach((el) => el.remove());

    const styleSheets = [
      ...document.querySelectorAll('link[rel="stylesheet"], style'),
    ]
      .map((el) => el.outerHTML)
      .join("\n");

    const printStyles = `
    <style>
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
          background: white;
        }
        #invoice-print-root {
          padding: 24px;
          max-width: 100%;
          width: 100%;
        }
        * {
          box-sizing: border-box;
        }
      }
    </style>
  `;

    const fullHTML = `
    <html>
      <head>
        <title>${fileName}</title>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <base href="${window.location.origin}/" />
        ${styleSheets}
        ${printStyles}
      </head>
      <body>
        <div id="invoice-print-root">${clone.innerHTML}</div>
      </body>
    </html>
  `;

    const win = window.open("", "_blank", "width=1200,height=1000");
    if (!win) return;

    win.document.write(fullHTML);
    win.document.close();
    win.focus();

    if (action === "print" || action === "download") {
      const triggerPrint = () => {
        setTimeout(() => {
          win.print();
          if (action === "print") win.close();
        }, 1000);
      };

      if (win.document.readyState === "complete") {
        triggerPrint();
      } else {
        win.addEventListener("load", triggerPrint);
      }
    }
  };

  const printInvoice = () =>
    openInvoiceWindow("print", `${data?.invoiceNum || "invoice"}`);
  const downloadInvoice = () =>
    openInvoiceWindow("download", `${data?.invoiceNum || "invoice"}.pdf`);
  const viewInvoice = () => openInvoiceWindow("view");

  const handleQbSync = async (entity) => {
    let baseUrl = WORKFORCE_API_URL;
    try {
      setQbLoading(true);
      const invoiceData = [];
      invoiceData.push(data);
      console.log("invoice data", invoiceData);

      let successCount = 0;
      let failedCount = 0;

      const buildVendorPayload = (data) => ({
        postActions: ["AddQBToVendor"],
        payload: {
          businessName: data?.businessName || "",
          uiid: data?.uiid || null,
          dbaName: data?.dbaName || "",
          email: data?.email || null,
          phone: data?.phone || null,
          website: data?.website || null,
          generalInfo: data?.generalInfo || null,
        },
      });

      const buildAPInvoicePayload = (invoice) => {
        const obj = invoice;
        return {
          ...(obj?.qbSync?.id && { qbSync: obj.qbSync }),
          uiid: obj?.uiid,
          invoiceNum: obj?.invoiceNum || undefined,
          invoiceBy: obj?.vendorId || undefined,
          employeeId: obj?.employeeId?.map((item) => item?.uiid) || undefined,
          approverId: obj?.approverId || undefined,
          vendorId: obj?.vendorId?.uiid || undefined,
          //as said incoive date is same a s billed dated
          invoiceDate: obj?.invoiceDate || undefined,
          billedDate: obj?.billedDate || undefined,
          dueDate: obj?.dueDate || undefined,
          netTerms: obj?.netTerms || undefined,
          amounts: obj?.amounts,
          // isModify: true,
          status: obj?.status || undefined,
          category: obj?.category || undefined,
          type: obj?.type || undefined,
          mailAddress: obj?.mailAddress || undefined,
          contacts: obj?.InvoiceContacts || undefined,
          emails: obj?.emails || undefined,
          invoiceDetails: obj?.invoiceDetails || [],
          discount:
            obj?.discounts?.map((item) => ({
              name: item?.name || undefined,
              type: item?.type || undefined,
              value: Number(item?.value) || undefined,
            })) || [],
          memo: obj?.memo || undefined,
          comments: obj?.comments || undefined,
        };
      };

      for (const invoice of invoiceData) {
        const vendorData = invoice.vendorId || {};
        const isVendorSynced = Boolean(vendorData?.qbSync?.id);

        if (!isVendorSynced) {
          try {
            const vendorPayload = buildVendorPayload(vendorData);
            await axios.post(`${baseUrl}/qb/vendors`, vendorPayload, {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            });
          } catch (err) {
            console.error("Customer Sync Failed:", err.response || err);
            failedCount++;
            continue;
          }
        }

        const isAPInvoiceSynced = Boolean(invoice?.qbSync?.id);
        const invoicePayload = buildAPInvoicePayload(invoice);

        try {
          if (!isAPInvoiceSynced) {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                postActions: ["AddQBToAccPay"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              }
            );
            successCount++;
          } else {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                update: true,
                postActions: ["AddQBToAccPay"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              }
            );
            successCount++;
          }
        } catch (err) {
          console.error("Invoice Sync Error:", err);
          failedCount++;
        }
      }

      showToast(
        `QuickBooks sync complete: ${successCount} bill(s) synced successfully, ${failedCount} failed.`,
        failedCount > 0 ? "warning" : "success",
        6000
      );
    } catch (err) {
      console.error("Unexpected QB Sync Error:", err);
      showToast("An unexpected error occurred during QuickBooks sync. Please try again.", "error", 5000);
    } finally {
      setQbLoading(false);
    }
  };
  const handleSave = async(status) => {
    let payload;
    payload = {
      status: status,
    };
    dispatch(
      updateAccountPayablesStart({
        coll: "AccountPayable",
        uiid: data.uiid,
        payload: [
          {
            type: "SET",
            value: payload,
          },
        ],
        onSuccess: async (resData) => {
          console.log({ resData });
          // navigate("/accounts-payable");
          if(status === 3) await handleQbSync("bills");
          onBack();
        },
      })
    );
  };

  return (
    <>
      {/* <div style={{ display: "none" }}></div> */}
      <div className=" flex flex-col" id="invoice-wrapper">
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
        <div className="flex justify-between">
          <img
            src={companyLogo}
            alt=""
            width={150}
            className="justify-center m-10"
          />
          <InvoicesHeader
            data={{
              // logo: companyLogo,
              title: "TekTree",
              // invoiceNumber: "86864813",
              invoiceNumber: data?.invoiceNum || "",
              invoiceStatus: "Waiting for approval",
              showButtons: true,
            }}
            onBack={onBack}
            // handleSave={handleSave}
            // buttonType="approve_reject"
          />
        </div>
        <div className="flex justify-between">
          <div>
            <InfoTimeCard
              title="Total Due"
              color="primary"
              // value={"147833.72"}
              value={formatCurrency(data?.amounts?.due) || ""}
              suffix={"USD"}
              type2
            />
          </div>
          <div className="flex h-10 gap-2" data-print="false">
            <Button
              size="sm"
              title={"Back"}
              icon={"arrow_left_alt"}
              onClick={onBack}
            />
            <Button
              size="sm"
              title={"Approve"}
              onClick={() => handleSave(3)}
              color={"success"}
            />
            <Button
              size="sm"
              title={"Reject"}
              onClick={() => handleSave(4)}
              color={"danger"}
            />
          </div>
        </div>
        <div className="flex gap-3 mt-3 ">
          <HeaderCard title={"From"}>
            <KeyValue
              oneLine={false}
              label={"TekTree LLC"}
              value={[
                "1106 Drummond Plaza, Newark, DE 19711",
                "accounts@tektreeinc.com",
                "www.tektreeinc.com",
              ]}
            />
          </HeaderCard>
          <HeaderCard title={"To"}>
            <KeyValue
              oneLine={false}
              // label={"ShubhaMinds, LLC"}
              label={data?.vendorId?.businessName || ""}
              // value={["10520 Chapell Hill road, #156", "Unnited States", "27560"]}
              value={data?.mailAddress?.split(",") || ""}
            />
          </HeaderCard>
          <HeaderCard title={"Invoice Details"}>
            <div className="flex flex-col gap-1">
              {/* <KeyValue label={"Invoice"} value={"#16444"} /> */}
              <KeyValue label={"Invoice"} value={data?.invoiceNum || ""} />
              {/* <KeyValue label={"Invoice Date"} value={"03/14/2025"} /> */}
              <KeyValue
                label={"Invoice Date"}
                value={dateFormator(data?.invoiceDate, "month-day-year")}
              />
              {/* <KeyValue label={"Shipped Date"} value={"03/14/2025"} /> */}
              <KeyValue
                label={"Shipped Date"}
                value={dateFormator(data?.invoiceDate, "month-day-year")}
              />
              {/* <KeyValue label={"Due Date"} value={"05/13/2025"} /> */}
              <KeyValue
                label={"Due Date"}
                value={dateFormator(data?.dueDate, "month-day-year")}
              />
              {/* //as said */}
              {/* <KeyValue label={"Class"} value={"???"} /> */}
              {/* <KeyValue label={"Terms"} value={"Net 60"} /> */}
              <KeyValue label={"Terms"} value={data?.netTerms || ""} />
            </div>
          </HeaderCard>
        </div>
        <div className="mt-3 shadow-md">
          <NewTable rows={mappedRows} columns={columns} hideToolBar showSlNo />
        </div>
        <div className="flex justify-end">
          <div className=" flex flex-col justify-start mt-4 max-w-[400px]  ">
            <div className=" text-black font-bold  flex gap-4 min-w-[400px] ">
              <div className="flex-1  justify-center text-center  border-white px-4 py-3">
                Subtotal
              </div>
              <div className="w-px bg-white mx-2" />
              <div className="flex-1 px-4 py-3">
                {data.amounts.billed + data.amounts.discount || ""}{" "}
                <span className="font-bold">USD</span>
              </div>
            </div>
            {/* {data?.discount?.map((item) =>
              item?.value ? (
                <div className="text-primary flex gap-4 min-w-[400px]">
                  <div className="flex-1 justify-center text-center border-white px-4 py-3">
                    {item?.name}
                  </div>
                  <div className="w-px bg-white mx-2" />
                  <div className="flex-1 px-4 py-3">
                    {`-${item?.value}`} <span className="font-bold">USD</span>
                  </div>
                </div>
              ) : null
            )} */}
            {data?.discount?.map((item) => {
              const billAmount = Number(data?.amounts?.billed) || 0;
              const value =
                item?.type === 1
                  ? (billAmount * Number(item?.value || 0)) / 100
                  : Number(item?.value || 0);

              return (
                <div
                  key={item?.name}
                  className="text-primary flex gap-4 min-w-[400px]"
                >
                  <div className="flex-1 justify-center text-center border-white px-4 py-3">
                    {item?.name}
                  </div>
                  <div className="w-px bg-white mx-2" />
                  <div className="flex-1 px-4 py-3">
                    {item?.type === 1
                      ? `-${Number(item?.value).toFixed(2)}% (-${value.toFixed(
                          2
                        )} USD)`
                      : `-${value.toFixed(2)} USD`}
                  </div>
                </div>
              );
            })}

            <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
              <div className="flex-1  justify-center text-center  border-white px-4 py-3">
                Total
              </div>
              <div className="w-px bg-white mx-2" />
              <div className="flex-1 px-4 py-3">{`${
                data?.amounts?.billed || " "
              } USD`}</div>
            </div>
            <div className="bg-black text-white  flex gap-4 min-w-[400px] mt-2">
              <div className="flex-1  justify-center text-center  border-white px-4 py-3">
                Due Total
              </div>
              <div className="w-px bg-white mx-2" />
              <div className="flex-1 px-4 py-3">{`${
                data?.amounts?.due || " "
              } USD`}</div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2" data-print="false">
          <div className="flex items-center gap-1">
            <p className="font-medium body-two">Statement Memo:</p>
            <span className="body-two font-sm">
              {/* Adeeb khan(02/01/2025 To 02/28/2025) */}
              {data?.memo || ""}
            </span>
          </div>
          <div>
            <Button
              // type="link"
              icon="download"
              size="sm"
              variant="text"
              color="info"
              title={"Accounts Payable PDF"}
              // onClick={() => handlePrintInvoice(data)}
              onClick={() => downloadInvoice()}
            />
          </div>
          <div className="hidden">
            <Button
              // type="link"
              icon="print"
              size="sm"
              variant="text"
              color="info"
              title={"Accounts Payable PDF"}
              // onClick={() => handlePrintInvoice(data)}
              onClick={() => printInvoice()}
            />
          </div>
          <div>
            <Button
              // type="link"
              icon="visibility"
              size="sm"
              variant="text"
              color="info"
              title={"Accounts Payable PDF"}
              // onClick={() => handlePrintInvoice(data)}
              onClick={() => viewInvoice()}
            />
          </div>

          <div className="mt-4">
            <PageHeader
              Section={
                <div className="flex">
                  <PageTitle title={"ATTACHMENTS"} tag="p" />
                </div>
              }
            />
            <Divider />
            <NewTable
              showCheckbox
              rows={mappedRows3}
              columns={Documemtcolumns}
              hideToolBar
            />
          </div>
          <div className="flex justify-center w-full mt-4">
            <div className="flex gap-3">
              <Button
                size="md"
                title={"Edit"}
                // onClick={() => setIsEditing(true)}
                onClick={() => navigate(`/accounts-payable/edit/${data.uiid}`)}
              />
              <Button size="md" title={"Cancel"} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WaitingforApprovalinvoiceDetails;
